<template>
  <div class="tw-w-screen tw-bg-bgMain tw-py-10 tw-px-4">
    <div
      class="tab-view-container tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="tw-w-full tw-text-center tw-text-xl tw-font-bold tw-text-textMain tw-mb-5"
        v-html="$t('首页小标题')"
      ></span>

      <div class="tw-flex tw-flex-col tw-w-full">
        <div class="tw-flex tw-w-full tw-justify-center">
          <swiper class="tabs-swiper tw-mb-5" :options="tabsSwiperOption">
            <swiper-slide v-for="item in tabsList" :key="item.categoryId">
              <div
                class="hover:tw-text-primary tw-font-medium tw-flex tw-items-center tw-justify-center tw-py-2 tw-text-sm tw-text-textLight tw-cursor-pointer"
                :class="{ 'tab-item-active': item.categoryId == activeTabId }"
                @click="handleTabClick(item)"
              >
                <span>{{ item.categoryName }}</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div class="tw-flex tw-overflow-hidden">
          <div
            class="tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col tw-relative"
          >
            <div
              class="tw-absolute tw-z-20 tw-w-18 tw-flex-none tw-flex tw-items-center tw-justify-end tw-pr-3 tw-h-full tw-left-2"
            >
              <span
                class="swiper-prev tw-cursor-pointer tw-w-8 tw-h-8 tw-bg-white tw-bg-opacity-90 tw-rounded-full tw-flex tw-items-center tw-justify-center"
              >
                <b-icon icon="chevron-left" class="tw-w-5 tw-h-5"></b-icon>
              </span>
            </div>

            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="item in swiperList" :key="item.id">
                <div
                  class="tw-flex tw-flex-col tw-w-full tw-h-full tw-relative cursor-pointer"
                  @click="handleClickRoute(item)"
                >
                  <img
                    class="tw-w-full tw-h-full tw-object-cover"
                    :src="
                      item.pic
                        ? item.pic
                        : 'require(@/assets/home/Group_bg.png)'
                    "
                    alt="Project Image"
                  />

                  <div
                    class="tw-w-full tw-h-full tw-flex tw-text-white tw-flex-col tw-justify-between tw-p-4 tw-absolute tw-top-0 tw-left-0 mark-lr"
                  >
                    <div
                      class="tw-w-full tw-items-center tw-justify-between tw-flex"
                    >
                      <span class="tw-flex-1 tw-text-base tw-font-medium">{{
                        item.name
                      }}</span>

                      <span
                        class="tw-text-sm tw-cursor-pointer tw-text-center tw-flex-none"
                        >{{ $t("了解更多") }}
                        <b-icon
                          icon="arrow-right"
                          class="tw-w-3 tw-h-3"
                        ></b-icon>
                      </span>
                    </div>

                    <span
                      class="tw-text-sm tw-transition-all tw-duration-300"
                      >{{ item.intro }}</span
                    >
                  </div>
                </div>
              </swiper-slide>
            </swiper>

            <div
              class="tw-absolute tw-z-20 tw-w-18 tw-flex-none tw-flex tw-items-center tw-justify-end tw-pr-3 tw-h-full tw-right-2"
            >
              <span
                class="swiper-next tw-cursor-pointer tw-w-8 tw-h-8 tw-bg-white tw-bg-opacity-90 tw-rounded-full tw-flex tw-items-center tw-justify-center"
              >
                <b-icon icon="chevron-right" class="tw-w-5 tw-h-5"></b-icon>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-5">
        <span
          class="tw-text-textLight tw-text-center tw-text-sm tw-cursor-pointer tw-py-1 tw-px-4 tw-border tw-rounded-sm hover:tw-text-primary hover:tw-border-primary"
          @click="handleToMore"
        >
          {{ $t("更多产品") }}
          <b-icon icon="chevron-right" class="tw-w-3 tw-h-3"></b-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "mobileTabView",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tabsList: [],
      isVisible: false,
      observer: null,
      activeTabId: 1,
      hoverId: -1,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
      },
      tabsSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    };
  },
  computed: {
    swiperList() {
      if (!this.tabsList || this.tabsList.length <= 0) {
        return [];
      }
      let item = this.tabsList.find(
        (item) => item.categoryId == this.activeTabId
      );
      if (item.products.length > 6) {
        return item.products.slice(0, 5);
      }
      return item.products;
    },
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem("indexInfo"));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleToMore() {
      let item = this.tabsList.find(
        (item) => item.categoryId == this.activeTabId
      );
      if (item) {
        this.$router.push({
          path: "/product?categoryId=" + item.categoryId + "&isApi=false",
        });
      }
    },

    handleHover(hover, id) {
      this.hoverId = hover ? id : -1;
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
          rootMargin: "0px 0px -50px 0px", // 提前50px触发
        }
      );

      this.observer.observe(this.$el);
    },
    getList() {
      let info = JSON.parse(localStorage.getItem("indexInfo"));
      this.tabsList = info.recommendProductList;
      if (this.tabsList.length > 0) {
        this.activeTabId = this.tabsList[0].categoryId;
      }
    },
    handleClickRoute(row) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/product/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/product",
        });
      }
    },
    handleTabClick(item) {
      this.activeTabId = item.categoryId;
    },
  },
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

::v-deep .nav-tabs {
  position: relative;
  width: 60%;
  border: none;
  color: black;
}

::v-deep .nav-link {
  color: black;
}

::v-deep .nav-link:hover {
  // font-weight: bold !important;
  background-color: rgba(0, 0, 0, 0.05) !important;
}

::v-deep .nav-item {
  .active {
    // color: red;
  }
}

::v-deep .nav-tabs .nav-link {
  border: none;
  color: black;
  // background: red;
}

::v-deep .nav-pills .nav-link {
  border-radius: 0;
}

::v-deep .nav-tabs .nav-link:hover,
.nav-tabs {
  border: none;
}

::v-deep .nav-item {
  position: relative;
  color: black;
  padding: 0 16px;
  font-size: 16px;
  border-radius: none;

  &::after {
    content: "";
    position: absolute;
    bottom: 8px;
    right: 0px;
    width: 1px;
    height: 22px;
    background: #dcdcdc;
  }
}

::v-deep .nav-item:last-child {
  position: relative;
  color: black;

  &::after {
    content: "";
    position: absolute;
    bottom: 8px;
    right: 0px;
    width: 1px;
    height: 22px;
    background: #fff;
  }
}

.project-item {
  width: 25%;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 10px;
  padding: 10px 10px;
  justify-content: space-around;

  &:hover {
    // transform: translateY(-2px);
    // box-shadow: 0 0 2px 2px #f7f8fa;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
}

.project-image {
  width: 100%;
  height: 200px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
}

.project-title {
  margin: 20px 0;
  font-size: 18px;
  font-weight: bold;
}

.project-desc {
  height: 80px;
  line-height: 20px;
  font-size: 14px;
  color: #666666;
}

.project-link {
  display: inline-block;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  font-size: 14px;
  text-decoration: none;
  border-radius: 3px;
  color: #666666;
  border: 1px solid #ccc;

  &:hover {
    cursor: pointer;
    color: #fff;
    background-color: #4077f8;
    border-color: #4077f8;
  }
}

.tab-item-active {
  position: relative !important;
  color: #4077f8 !important; // 激活状态的文字颜色
  transition: all 0.3s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    bottom: -2px; // 调整位置，让线条更贴近文字
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #4077f8;
  }
}

.swiper {
  height: 200px;
  width: 100%;

  .swiper-slide {
    display: flex;
  }
}

.mark-lr {
  background: linear-gradient(
    90deg,
    rgba(63, 118, 247, 1),
    rgba(63, 118, 247, 0)
  );
}

.mark-bt {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(153, 153, 153, 0.2) 70%,
    rgba(153, 153, 153, 0.6) 85%,
    #999 100%
  );
}
</style>
